import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/app/(auth)/login/page.tsx");
